import type { HeldItem } from "./types";

const heldItems: HeldItem[] = [
  { id: "aeos-cookie", image: "held-items/aeos-cookie.webp", name: "Aeos Cookie" },
  { id: "attack-weight", image: "held-items/attack-weight.webp", name: "Attack Weight" },
  { id: "special-attack-specs", image: "held-items/special-attack-specs.webp", name: "Sp. Atk Specs" },
  { id: "shell-bell", image: "held-items/shell-bell.webp", name: "Shell Bell" },
  { id: "float-stone", image: "held-items/float-stone.webp", name: "Float Stone" },
  { id: "muscle-band", image: "held-items/muscle-band.webp", name: "Muscle Band" },
  { id: "scope-lens", image: "held-items/scope-lens.webp", name: "Scope Lens" },
  { id: "wise-glasses", image: "held-items/wise-glasses.webp", name: "Wise Glasses" },
  { id: "leftovers", image: "held-items/leftovers.webp", name: "Leftovers" },
  { id: "exp-share", image: "held-items/exp-share.webp", name: "Exp. Share" },
  { id: "focus-band", image: "held-items/focus-band.webp", name: "Focus Band" },
  { id: "energy-amplifier", image: "held-items/energy-amplifier.webp", name: "Energy Amplifier" },
  { id: "buddy-barrier", image: "held-items/buddy-barrier.webp", name: "Buddy Barrier" },
  { id: "score-shield", image: "held-items/score-shield.webp", name: "Score Shield" },
  { id: "assault-vest", image: "held-items/assault-vest.webp", name: "Assault Vest" },
  { id: "rocky-helmet", image: "held-items/rocky-helmet.webp", name: "Rocky Helmet" },
  { id: "razor-claw", image: "held-items/razor-claw.webp", name: "Razor Claw" },
  { id: "choice-specs", image: "held-items/choice-specs.webp", name: "Choice Specs" },
  { id: "weakness-policy", image: "held-items/weakness-policy.webp", name: "Weakness Policy" },
  { id: "rapid-fire-scarf", image: "held-items/rapid-fire-scarf.webp", name: "Rapid-Fire Scarf" },
  { id: "drain-crown", image: "held-items/drain-crown.webp", name: "Drain Crown" },
  { id: "slick-spoon", image: "held-items/slick-spoon.webp", name: "Slick Spoon" },
  { id: "rescue-hood", image: "held-items/rescue-hood.webp", name: "Rescue Hood" },
  { id: "curse-bangle", image: "held-items/curse-bangle.webp", name: "Curse Bangle" },
  { id: "curse-incense", image: "held-items/curse-incense.webp", name: "Curse Incense" },
  { id: "charging-charm", image: "held-items/charging-charm.webp", name: "Charging Charm" },
  { id: "resonant-guard", image: "held-items/resonant-guard.webp", name: "Resonant Guard" },
  { id: "drive-lens", image: "held-items/drive-lens.webp", name: "Drive Lens" },
  { id: "accel-bracer", image: "held-items/accel-bracer.webp", name: "Accel Bracer" },
  { id: "amulet-coin", image: "held-items/amulet-coin.webp", name: "Amulet Coin" },
  { id: "choice-scarf", image: "held-items/choice-scarf.webp", name: "Choice Scarf" },
  { id: "big-root", image: "held-items/big-root.webp", name: "Big Root" },
  { id: "tenacity-belt", image: "held-items/tenacity-belt.webp", name: "Tenacity Belt" },
  { id: "vanguard-bell", image: "held-items/vanguard-bell.webp", name: "Vanguard Bell" },
  { id: "rusted-sword", image: "held-items/rusted-sword.webp", name: "Rusted Sword", exclusive: "Zacian" },
  { id: "mewtwonite-x", image: "held-items/mewtwonite-x.webp", name: "Mewtwonite X", exclusive: "Mewtwo" },
  { id: "mewtwonite-y", image: "held-items/mewtwonite-y.webp", name: "Mewtwonite Y", exclusive: "Mewtwo" },
  { id: "lucarionite", image: "held-items/lucarionite.webp", name: "Lucarionite", exclusive: "Lucario" },
  { id: "charizardite-x", image: "held-items/charizardite-x.webp", name: "Charizardite X", exclusive: "Charizard" },
  { id: "charizardite-y", image: "held-items/charizardite-y.webp", name: "Charizardite Y", exclusive: "Charizard" },
  { id: "gyaradosite", image: "held-items/gyaradosite.webp", name: "Gyaradosite", exclusive: "Gyarados" },
];

export default heldItems;
